import {Component, ElementRef} from "@angular/core";

import {AbstractViewComponent} from "../abstract-view/abstract-view.component";

import {BaseDataType} from "../../base-data-type";

import {AppService} from "../../app.service";
import {ActivatedRoute} from "@angular/router";
import {FormGroup, FormControl, Validators} from "@angular/forms";
import { MainViewComponent } from "../main-view.component";

@Component({
  selector: "app-belriv-dimensions",
  templateUrl: "./belriv-dimensions.component.html",
  styleUrls: ["./belriv-dimensions.component.scss"]
})

export class BelrivDimensionsComponent extends AbstractViewComponent {

    public readonly TAG: string = "[BelrivDimensionsComponent]";

    public type: BaseDataType;
    private typeForm: FormGroup;

    protected selectedFacadeOption: string;

    private mainViewElement: ElementRef;

    /**
     * Main form data dictionary.
     */
    public valuesDictionary: { [key: string]: number };

    constructor(private mainView: MainViewComponent, protected route: ActivatedRoute) {
        super(route);

        this.mainViewElement = mainView.getMainViewElement();
    }

    public getData(): void {
        super.getData();

        if (!this.confDataService.getElementOptions("project-type")) { return; }

        this.selectedFacadeOption = this.confDataService.getElementOptions("project-type").find(typeId => typeId.indexOf("facade") !== -1);
        const selectedBelrivOption: string = this.confDataService.getElementOptions("project-type").find(typeId => typeId.indexOf("belriv") !== -1);

        console.log("SELECTED FACADE OPTION", this.selectedFacadeOption);

        if (selectedBelrivOption === undefined)  { return; }

        this.appService.getType(AppService.BELRIV_DIMENSIONS_URL, selectedBelrivOption)
        .then(type => {
            this.type = type;
        });
    }

    // protected onClickValidate(e: MouseEvent): void
    // {
    //     console.log(this.TAG, "onClickValidate()", e);

    //     console.log(this.TAG, this.route.snapshot);

    //     if (this.validateForm() === false) { return; }

    //     const commands: string[] = ["/lang", this.lang, this.route.snapshot.url[2].toString(), "accessories-type"];
    //     console.log(this.TAG, "COMMANDS", commands);
    //     this.router.navigate(commands);
    // }

    private validateForm(): boolean
    {
        const values: any[] = this.confDataService.getElementValues("belriv-dimensions");

        // Total values needed depending on belriv type and facade option type.
        let totalValuesLength: number;
        // Belriv Systeme
        if (this.type.id === "belriv-systeme")
        {
            totalValuesLength = this.selectedFacadeOption === "facade-pignon" ? 2 : 1;
        // Belriv Tradition
        } else {
            totalValuesLength = this.selectedFacadeOption === "facade-pignon" ? 4 : 2;
        }

        if (!values || (values.length > 0 && Object.keys(values[0]).length < totalValuesLength))
        {

            this.confDataService.updateElementValues("belriv-dimensions-valid", ["false"]);
            return false;
        }

        this.confDataService.updateElementValues("belriv-dimensions-valid", ["true"]);
        return true;
    }

    public storedValue(pTypeId): boolean
    {
        const values: any[] = this.confDataService.getElementValues("belriv-dimensions");
        if (values && values.length > 0)
        {
            return values[0][pTypeId] !== undefined;
        }
        return false;
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.scrollToBottom();

        this.confDataService.observable.subscribe(
            value => {
                console.log(this.TAG, "VALUE CHANGED", value);

                this.scrollToBottom();

                if (value.id === "project-type")
                {
                    this.getData();
                }
                
                // To force validation update
                if (value.id === "belriv-dimensions") {
                    this.validateForm();
                }
            }
        );

    }

    private scrollToBottom() {
        setTimeout(() => {
            if(this.mainViewElement.nativeElement.scrollHeight > this.mainViewElement.nativeElement.offsetHeight) {
                this.mainViewElement.nativeElement.style.scrollBehavior = 'smooth';
                this.mainViewElement.nativeElement.scrollTop = this.mainViewElement.nativeElement.scrollHeight;
            }
        }, 50);
    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/belriv-dimensions/belriv-dimensions.component.ts